import { searchAssets, useUserContext } from "@dexteel/mesf-core";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAssetFullPath } from "../components/hooks/useGetAssetFullPath";
import { useAssetDetailsContext } from "../context/assetDetailsContext";

type Props = {
  setIsLoading: (isLoading: boolean) => void;
  setError: (err: string) => void;
};

export const useInitializeAssetDetails = ({
  setIsLoading,
  setError,
}: Props) => {
  const {
    state: { defaultAreaId },
  } = useUserContext();

  const { data: allAssets } = searchAssets();

  const navigate = useNavigate();
  const isMountRef = useRef(true);

  const { actions } = useAssetDetailsContext();

  const { AssetIdParam } = useParams();

  const { GetAssetFullPath } = useGetAssetFullPath({ setIsLoading, setError });
  useEffect(() => {
    if (allAssets && allAssets?.length > 0) {
      if (AssetIdParam !== undefined && AssetIdParam !== null) {
        GetAssetFullPath(AssetIdParam);
        actions.setAssetSearchId(AssetIdParam);

        const parsedAssetId = Number.parseInt(AssetIdParam!);

        let assetNameToShow;

        if (parsedAssetId === 0) {
          assetNameToShow = "Plant";
        } else {
          const foundAsset = allAssets?.find(
            (asset) => asset.AssetId === parsedAssetId
          );
          assetNameToShow = foundAsset?.AssetName || "Unknown";
        }

        actions.setAssetSearchName(assetNameToShow);
      }
    }
  }, [AssetIdParam, defaultAreaId, allAssets]);

  useEffect(() => {
    isMountRef.current = false;
  }, []);
};
